import type { SearchColumnDef } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export const getDocumentsColumns = (): SearchColumnDef[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt
  },
  {
    field: 'so_luong0',
    headerName: 'Số lượng lấy',
    type: 'number',
    width: 100,
    renderCell: params => params.row.sl_cl
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    renderCell: params => formatMoney(params.row.so_luong)
  },
  {
    field: 'sl_cl',
    headerName: 'Số lượng còn',
    width: 100,
    type: 'number',
    renderCell: params => formatMoney(params.row.sl_cl)
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Mã vị trí',
    width: 120,
    renderCell: params => params.row.ma_vi_tri_data?.ma_vi_tri
  },
  {
    field: 'gia_nt',
    headerName: 'Giá tồn VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.gia_nt)
  },
  {
    field: 'tien_nt',
    headerName: 'Tiền VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt)
  },
  {
    field: 'gia_nt1',
    headerName: 'Giá chuẩn VND',
    type: 'number',
    width: 170,
    renderCell: params => formatMoney(params.row.gia_nt1)
  },
  {
    field: 'gia_nt2',
    headerName: 'Giá bán VND',
    type: 'number',
    width: 170,
    renderCell: params => formatMoney(params.row.gia_nt2)
  },
  {
    field: 'tien_nt2',
    headerName: 'Doanh số VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt2)
  },
  {
    field: 'ck_nt',
    headerName: 'Chiết khấu NT',
    type: 'number',
    width: 120,
    renderCell: params => formatMoney(params.row.ck_nt)
  },
  {
    field: 'tk_thue',
    headerName: 'Tk thuế có',
    width: 120,
    renderCell: params => params.row.tk_thue_co_data?.code
  },

  {
    field: 'thue_suat',
    headerName: 'Thuế suất (%)',
    type: 'number',
    width: 120,
    renderCell: params => params.row.ma_thue_data?.thue_suat
  },
  {
    field: 'thue_nt',
    headerName: 'Thuế VND',
    type: 'number',
    width: 120,
    renderCell: params => params.row.thue_nt
  },
  {
    field: 'tk_tl',
    headerName: 'TK trả lại',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.tk_tl_data?.code
  },
  {
    field: 'tk_gv',
    headerName: 'TK giá vốn',
    width: 120,
    renderCell: params => params.row.tk_gv_data?.code
  },
  {
    field: 'tk_vt',
    headerName: 'TK kho',
    width: 120,
    renderCell: params => params.row.tk_vt_data?.code
  },
  {
    field: 'tk_km',
    headerName: 'TK khuyến mãi',
    width: 120,
    renderCell: params => params.row.tk_km_data?.code
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => params.row.ma_vv_data?.ma_vv
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => params.row.ma_hd_data?.ma_hd
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200,
    renderCell: params => params.row.dien_giai
  }
];
